import { useQuery } from "@apollo/client";
import { AvatarProps } from "@/shared/data-display/avatar";
import { GET_AVATAR_LINK } from "../api/get-avatar-link";
import { HidableAvatarView } from "../ui/hidable-avatar-view";

/**
 * Аватар, когда на руках только идентификатор человека. Запрос живёт здесь, а не в
 * `PersonAvatar`, чтобы вызовы с готовыми данными не тянули за собой Apollo.
 */
export function PersonAvatarById({
  personId,
  ...avatarProps
}: AvatarProps & { personId: string | undefined }) {
  const { data } = useQuery(GET_AVATAR_LINK, {
    variables: { id: personId as string },
    skip: !personId,
  });

  return (
    <HidableAvatarView {...avatarProps} data={data?.getPersonById.avatar} />
  );
}
